<template>
    <div class="mission-section" id="mission-purpose">
        <div class="container">
            <div class="mission-items">
                <div class="item">
                    <h2 class="mobile-title" v-if="isMobileChecker">{{ aboutPage.mission.title }}</h2>
                    <div class="item-img item-img-mobile" :style="'background-image: url(' + aboutPage.mission.img_mobile + ')'" v-if="isMobileChecker"></div>
                    <div class="item-img" :style="'background-image: url(' + aboutPage.mission.img + ')'" v-if="!isMobileChecker"></div>
                    <div class="item-desc">
                        <h2 v-if="!isMobileChecker">{{ aboutPage.mission.title }}</h2>
                        <div class="desc" v-html="aboutPage.mission.desc"></div>
                    </div>
                </div>
                <div class="item">
                    <h2 class="mobile-title" v-if="isMobileChecker">{{ aboutPage.purpose.title }}</h2>
                    <div class="item-img item-img-mobile" :style="'background-image: url(' + aboutPage.purpose.img_mobile + ')'" v-if="isMobileChecker"></div>
                    <div class="item-img" :style="'background-image: url(' + aboutPage.purpose.img + ')'" v-if="!isMobileChecker"></div>
                    <div class="item-desc">
                        <h2 v-if="!isMobileChecker">{{ aboutPage.purpose.title }}</h2>
                        <div class="desc" v-html="aboutPage.purpose.desc"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    export default {
        name: 'mission-section',
        components: {
        },
        data () {
            return {
            }
        },
        computed: mapGetters({
            aboutPage: 'loadAboutPage',
            isMobileChecker: 'loadIsMobileChecker',
        }),
        methods: {
        },
        created () {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/about/mission-section.scss';
    @import '@/styles/components/about/respond/mission-section-respond.scss';
</style>